import styled from "styled-components";
import type { CameraWithAnalysisConfig } from "~/_legacy/types/analysis";
import { toProxiedImageUrl } from "~/shared/lib/image-proxy";
import { TEMP_IMAGE_URL } from "~/shared/ui/EmptyImagePlaceholder";
import { SLOT_SIZE } from "./slot-layout";

export interface SlotPlacement {
  camera: CameraWithAnalysisConfig;
  cameraViewport: { x: number; y: number };
  slotViewport: { x: number; y: number };
  slotConnectingViewport: { x: number; y: number };
}

interface Props {
  width: number;
  height: number;
  placements: SlotPlacement[];
}

export function SlotOverlay({ width, height, placements }: Props) {
  if (placements.length === 0) return null;

  return (
    <Root>
      <Lines width={width} height={height}>
        {placements.map(({ camera, cameraViewport, slotConnectingViewport }) => (
          <line
            key={camera.id}
            x1={cameraViewport.x}
            y1={cameraViewport.y}
            x2={slotConnectingViewport.x}
            y2={slotConnectingViewport.y}
            stroke="#329EFF"
            strokeWidth={1.5}
            strokeDasharray="4 3"
          />
        ))}
      </Lines>
      {placements.map(({ camera, slotViewport }) => (
        <SlotBox
          key={camera.id}
          style={{
            left: slotViewport.x,
            top: slotViewport.y,
            width: SLOT_SIZE.width,
            height: SLOT_SIZE.height,
          }}
        >
          <SlotImage
            src={toProxiedImageUrl(camera.previewImageUrl) || TEMP_IMAGE_URL}
            alt={camera.analysisNumber ?? ""}
          />
          {camera.analysisNumber && <SlotLabel>{camera.analysisNumber}</SlotLabel>}
        </SlotBox>
      ))}
    </Root>
  );
}

const Root = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
`;

const Lines = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

const SlotBox = styled.div`
  position: absolute;
  background: #fff;
  border: 1px solid #484BD2;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
`;

const SlotImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const SlotLabel = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 2px 6px;
  background: #484BD2;
  color: #fff;
  border-radius: 3px;
  font-family: Pretendard Variable, Pretendard, sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
`;
